const qs = document.querySelector.bind(document);

export const togglePasswordShowHide = (passwordField, forceHide = false, togglePasswordEl = qs('.show-hide')) => {
    if (forceHide) {
        if (passwordField.type === 'text') {
            togglePasswordShowHide(passwordField, false, togglePasswordEl);
        }
        return;
    }
    passwordField.type = passwordField.type === 'password' ? 'text' : 'password';

    togglePasswordEl.classList.toggle('ifi-eye-open');
    togglePasswordEl.classList.toggle('ifi-eye-close');
};

export const initPasswordShowHide = (passwordField, togglePasswordEl = qs('.show-hide')) => {
    if (!passwordField || !togglePasswordEl) {
        return;
    }

    togglePasswordEl.addEventListener('click', function(e) {
        e.preventDefault();
        togglePasswordShowHide(passwordField, false, togglePasswordEl);
    });
};

export default initPasswordShowHide;